import { Avatar, Button, Col, Modal, Popover, Row, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GetPlansDetailsApi from "../../api/plans/GetPlanDetailsApi";
import { getTargetString } from "../../helpers/targetHelpers";
import moment from "moment";
import { InfoCircleOutlined, UserOutlined } from "@ant-design/icons";

function PlanInfoModal(props) {
  const [planDetails, setPlanDetails] = useState();

  useEffect(() => {
    if (props.planId) {
      getPlanData();
    }
  }, [props.planId]);

  async function getPlanData() {
    const apiResponse = await GetPlansDetailsApi(props.planId);
    if (apiResponse.message === "success") {
      setPlanDetails(apiResponse.plan);
    }
  }

  return (
    <Modal
      title={"Plan details"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Row gutter={16}>
        <Col span={24}>
          <div className="text-xs">Plan name</div>
          <div className="mb-3">{planDetails?.title}</div>
        </Col>
        <Col span={12}>
          <div className="text-xs">Target</div>
          <div className="mb-3">
            {getTargetString(
              planDetails?.targetAchieved,
              planDetails?.scale?.scaleName,
              planDetails?.scale?.scaleUnitAbbreviation
            )}{" "}
            /{" "}
            {getTargetString(
              planDetails?.target,
              planDetails?.scale?.scaleName,
              planDetails?.scale?.scaleUnitAbbreviation
            )}
          </div>
        </Col>
        {planDetails?.targetDate && (
          <Col span={12}>
            <div className="text-xs">Target date</div>
            <div className="mb-3">
              {moment(planDetails?.targetDate).format("DD.MM.YYYY")}
            </div>
          </Col>
        )}
        <Col span={12}>
          <div className="text-xs">Plan group</div>
          <div className="mb-3">
            <Tag>{planDetails?.planGroup}</Tag>
          </div>
        </Col>
        {planDetails?.description && (
          <Col span={12}>
            <div className="text-xs">Description</div>
            <div className="mb-3">{planDetails?.description}</div>
          </Col>
        )}
        <Col span={12}>
          <div className="text-xs mb-1">Unit</div>
          <div className="flex items-center">
            <div
              className="w-2 h-2 mr-1 rounded-full"
              style={{ backgroundColor: planDetails?.unit?.orgLevelColor }}
            />
            <div>{planDetails?.unit?.name}</div>
            <Popover
              placement="top"
              content={
                <div className="text-xs">
                  {planDetails?.unit?.name}
                  {planDetails?.unit?.headUnit &&
                    " < " + planDetails?.unit?.headUnit?.name}
                  {planDetails?.unit?.headUnit?.headUnit &&
                    " < " + planDetails?.unit?.headUnit?.headUnit?.name}
                </div>
              }
              trigger="hover"
            >
              <div className="text-gray-500 text-xs ml-1">
                <InfoCircleOutlined />
              </div>
            </Popover>
          </div>
        </Col>
        <Col span={12}>
          <div className="text-xs mb-1">Assigned to</div>
          <div className="flex items-center">
            {planDetails?.assignedTo?.imageUrl ? (
              <Avatar
                className="cursor-pointer"
                src={planDetails?.assignedTo?.imageUrl}
              />
            ) : (
              <Avatar>
                {planDetails?.assignedTo?.firstName ? (
                  planDetails?.assignedTo?.firstName?.charAt(0).toUpperCase()
                ) : (
                  <UserOutlined />
                )}
              </Avatar>
            )}
            <div className="ml-2">
              <div>{planDetails?.assignedTo?.firstName || "-"}</div>
              <div className="text-xs -mt-1">
                {planDetails?.assignedTo?.designationAbb}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className="flex justify-between">
        <div></div>
        <Link to={`/top-plans/${planDetails?.planId}`}>
          <Button>View more</Button>
        </Link>
      </div>
    </Modal>
  );
}

export default PlanInfoModal;
